import {BrandInfo} from "@/lib/queries/accounts.ts";

export const getStatusPagePreviewURL = (brand: BrandInfo, id: number, publicURL?: string) => {
  return publicURL ? `${brand.siteURL}${publicURL}` : `${brand.siteURL}/statuspages/${id}/p`;
};
